import * as React from 'react';

import { Actions } from './components/actions';
import { Templates } from './components/templates';
import { useEmailTemplatesController } from './controllers/main';
import { MODULE_NAME } from './email-templates.constants';
import { MessageBox } from '@common/components/MessageBox';
import { TemplateManagement } from './components/template-management';
import { FieldSelector } from '@common/components/FieldSelector/FieldSelector';
import { ToolbarCustomButtonType } from '@common/components/text-editor/text-editor.types';

import './email-templates.styles.scss';

export const EmailTemplates: React.FC = () => {
  const {
    templateHasChanged,
    loadingTemplates,
    templates,
    currentEditingTemplate,
    closeMessage,
    messageProps,
    selectedTemplates,
    handleTemplateDelete,
    handleTemplateSave,
    handleTemplateLocalChange,
    handleTemplateCopy,
    handleTemplateCreate,
    handleTemplatesSelect,
    editorState,
    openFieldSelector,
    closeFieldSelector,
    handleFieldSelect,
    handleGetFolders,
    handleGetFields
  } = useEmailTemplatesController();

  return (
    <div className="EmailTemplates">
      <MessageBox hideMessageBox={closeMessage} {...messageProps} />
      <Actions
        className='EmailTemplates__actions'
        onTemplateDelete={handleTemplateDelete}
        onTemplateSave={handleTemplateSave}
        onTemplateCopy={handleTemplateCopy}
        onTemplateCreate={handleTemplateCreate}
        disabledState={{
          save: !templateHasChanged,
          newTemplate: false,
          deleteTemplate: false,
          copyTemplate: selectedTemplates.size !== 1,
        }}
      />
      <Templates
        className="EmailTemplates__templates"
        selectedTemplates={selectedTemplates}
        onSelectedTemplateChange={handleTemplatesSelect}
        moduleName={MODULE_NAME}
        data={templates}
        loading={loadingTemplates}
      />
      {editorState?.addContent && (
        <FieldSelector
          withSearch
          getFolders={handleGetFolders}
          getFields={handleGetFields}
          onChange={handleFieldSelect}
          close={closeFieldSelector}
        />
      )}
      <TemplateManagement
        disabled={selectedTemplates.size !== 1}
        className="EmailTemplates__template-management"
        onTemplateChange={handleTemplateLocalChange}
        template={currentEditingTemplate}
        toolbarCustomButtons={[
          { type: ToolbarCustomButtonType.name },
          { type: ToolbarCustomButtonType.link },
          { type: ToolbarCustomButtonType.field },
        ]}
        onFieldButtonClick={openFieldSelector}
      />
    </div>
  );
};